<template>
  <div class="project-view">
    <Header
      :set-backdrop="false"
    >
      <img 
        class="project-view__banner"
        :src="require('@/assets/img/projects/logo.png')" 
        alt="Banner" 
      />
    </Header>

    <MainHeading 
      :heading="projectName" 
    />
    
    <AppCarousel 
      :items="items" 
      :slides="photoList"
      :is-loading="isLoading"
      @fetch-photos="fetchPhotos($event)"
      backdrop-content
    />
  </div>
</template>

<script>
import Header from '@/components/Header/Header.vue'
import MainHeading from "@/components/MainHeading/MainHeading.vue";
import API from '@/services/api'
import { mapGetters, mapActions } from 'vuex'
import AppCarousel from '@/components/common/AppCarousel.vue'

  export default {
    name: 'ProjectView',

    components: {
      Header,
      MainHeading,
      AppCarousel
    },
    
    data: () => ({
      collapsibleVisible: false
    }),

    computed: {
      ...mapGetters('photos', ['photoList']),
      ...mapGetters('loader', ['isLoading']),

      projectName() {
        return this.$route.params.name || 'Proyecto'
      },
      photos() {
        return this.photoList
      },
      items() {
        return Array.from({ length: this.$route.query.count }, (item, idx) => { return { label: `DÍA ${ idx + 1 }`, index: idx + 1 }})
      }
    },

    title() {
      return "Proyectos | SHI'RRAIN WAYUU";
    },

    methods: {
      ...mapActions('photos', ['setPhotos']),
      ...mapActions('loader', ['setLoading']),

      fetchPhotos(query) {
        this.setPhotos([])
        
        if ( !query.length )
          return window.console.error('Query is missing')

        this.setLoading(true)

        return API.listPhotos({ data: { searchQuery: query } })
        .then(({ data }) => this.setPhotos(data))
        .catch(err => window.console.log(err))
        .finally(() => this.setLoading(false))
      }
    }
  }
</script>

<style lang="scss" scoped>
  .project-view {
    &__banner {
      display: block;
      margin: auto;
      width: 100%;
    }

    &__content {
      margin-top: 6rem;
    }
  }
</style>